import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {canLoadGuard} from './shared/guards/can-load.guard';
import {canActivateGuard} from './shared/guards/can-activate.guard';
import {canActivateChildGuard} from './shared/guards/can-activate-child.guard';
import {SettingsLayoutComponent} from './features/settings-new/components/settings-layout/settings-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.module').then(m => m.LoginPageModule),
    canMatch: [canLoadGuard],
  },
  {
    path: 'settings',
    loadChildren: () => import('./features/settings-new/settings-new-module').then(m => m.SettingsNewModule),
  },
  {
    path: 'home',
    loadChildren: () => import('./features/home/home.module').then(m => m.HomePageModule),
  },
  {
    path: 'auto-ordering',
    loadChildren: () => import('./features/auto-ordering/auto-ordering.module').then(m => m.AutoOrderingPageModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'barcode-scanner',
    loadChildren: () => import('./features/barcode-scanner/barcode-scanner.module').then(m => m.BarcodeScannerModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'ngp-report',
    loadChildren: () => import('./features/ngp-report/ngp-report.module').then(module => module.NgpReportModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'quotes',
    loadChildren: () => import('./features/quotes/quotes.module').then(module => module.QuotesModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'dashboard-reporting',
    loadChildren: () => import('./features/dashboard-reporting/dashboard-reporting.module').then(m => m.DashboardReportingModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  { // Is this module still relevant?
    path: 'save-user-settings',
    loadChildren: () => import('./shared-modules/shared-module/modules-old/save-user-settings/save-user-settings.module').then(m => m.SaveUserSettingsPageModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'shelf-talkers',
    loadChildren: () => import('./features/shelf-talkers/shelf-talkers.module').then(m => m.ShelfTalkersPageModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'stock-manager',
    loadChildren: () => import('./features/stock-manager/stock-manager.module').then(m => m.StockManagerModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'stock-match',
    loadChildren: () => import('./features/product-mapping/product-mapping.module').then(m => m.ProductMappingModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'stock-take',
    loadChildren: () => import('./features/stock-take/stock-take.module').then(m => m.StockTakeModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'user-access',
    loadChildren: () => import('./features/user-access/user-access.module').then(m => m.UserAccessPageModule),
    canMatch: [canLoadGuard],
    canActivate: [canActivateGuard],
    canActivateChild: [canActivateChildGuard],
  },
  {
    path: 'auth',
    loadComponent: () => import('./shared/components/auth-placeholder/auth-placeholder.component').then(c => c.AuthPlaceholderComponent),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
